import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-system-maintenance',
  templateUrl: './system-maintenance.component.html',
  styleUrls: ['./system-maintenance.component.scss']
})
export class SystemMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
